module.exports = __webpack_public_path__ + "media/images/default/shared/footer/top-c21ec9b56a1cc63b81c6758950ca7bc8.svg";